import { connect } from 'react-redux'

import HtmlSection from 'components/home-page/views/sections/html'

const mapStateToProps = (state, ownProps) => ({
  meta: state.homePageRevision.revision.sections[ownProps.sectionId].meta,
  theme: state.homePageRevision.revision.sections[ownProps.sectionId].theme
})

export default connect(mapStateToProps)(HtmlSection)
